import { FunctionComponent } from "react"
import { Col, Row } from "react-bootstrap"
import Button from "react-bootstrap/Button"
import Card from "react-bootstrap/Card"
import { useNavigate } from "react-router-dom"
import { Group } from "../data/models"
import PrivateComponent from "./PrivateComponent"

interface IRoutersCard {}
const RoutersCard: FunctionComponent<IRoutersCard> = () => {
	const navigate = useNavigate()
	return (
		<Card>
			<Card.Header>Routers</Card.Header>
			<Card.Body>
				<Card.Text>View router status. Lookup or reset wifi password. Change internet plan.</Card.Text>
				<Row className="mt-4">
					<Col xs="auto">
						<Button variant="primary" className="mt-3" onClick={() => navigate("routers")}>
							View Routers
						</Button>
					</Col>
					<Col></Col>
					<PrivateComponent groups={[Group.InternetManagementAdmin, Group.GlobalAdmin]}>
						<Col xs="auto">
							<Button variant="primary" className="mt-3" onClick={() => navigate("routers/create")}>
								Create Routers
							</Button>
						</Col>
					</PrivateComponent>
				</Row>
			</Card.Body>
		</Card>
	)
}
export default RoutersCard
